import { Transform, Type } from "class-transformer";
import { BaseEntityDto } from "@/core/common/entities/base-entity.dto";
import { CompanyDto } from "@/core/features/companies/company.dto";
import { SupplierDto } from "@/core/features/suppliers/supplier.dto";
import { UserDto } from "@/core/features/users/user.dto";
import { FileDto } from "@/core/features/file/file.dto";
import { parseApiDate } from "@/utils/dates/dateFormats";
import { toEuros } from "@/utils/numberUtils";
import { SupplierInvoiceLineDto } from "./supplier-invoice-line.dto";
import { SupplierInvoiceTaxLineDto } from "./supplier-invoice-tax-line.dto";
import { SupplierInvoiceStatusEnum } from "@altertec_gparn/lib";

export class SupplierInvoiceDto extends BaseEntityDto {
  numeration?: string;

  status: SupplierInvoiceStatusEnum;

  @Transform(({ value }) => parseApiDate(value))
  date: Date;

  @Transform(({ value }) => parseApiDate(value))
  expirationDate?: Date;

  @Transform(({ value }) => toEuros(value))
  subtotalAmount?: number;

  @Transform(({ value }) => toEuros(value))
  totalTaxAmount?: number;

  @Transform(({ value }) => toEuros(value))
  totalAmount?: number;

  cif?: string;

  companyId?: string;

  @Type(() => CompanyDto)
  company?: CompanyDto;

  supplierId?: string;

  @Type(() => SupplierDto)
  supplier?: SupplierDto;

  assigneeId?: string;

  @Type(() => UserDto)
  assignee?: UserDto;

  fileId: string;

  @Type(() => FileDto)
  file: FileDto;

  @Type(() => SupplierInvoiceLineDto)
  lines?: SupplierInvoiceLineDto[];

  @Type(() => SupplierInvoiceTaxLineDto)
  taxLines?: SupplierInvoiceTaxLineDto[];

  processData?: any;

  toString(): string {
    return this.numeration || "Sin numeración";
  }
}
